import HK from "./main/hk/index.js"
import KR from "./main/kr/index.js"
import store from "@/store/index.js"

const dict = {
    HK,
    KR
}

let language = store.state.language

export default dict[language]